




























import Vue, { PropType } from "vue";
import { ValidationProvider } from "vee-validate";
import { ReportTypeEnum, ReportTypeEnumInterface } from "@/features/analytics/enums/ReportType";
import { Enum } from "@/commons/enums/Type";

export default Vue.extend({
  components: {
    "validation-provider": ValidationProvider,
  },
  props: {
    reportTypeInput: { type: Number, required: true },
    reportType: { type: Array as PropType<Enum[]>, required: true },
    reportTypeDialog: { type: Boolean, required: true },
    reportTypeInputDisplay: { type: Number, required: true },
    clickOkOnReportTypeDialog: {
      type: Function as PropType<() => void>,
      required: true,
    },
    clickCancelOnReportTypeDialog: {
      type: Function as PropType<() => void>,
      required: true,
    },
  },
  data() {
    return {
      reportTypeEnum: ReportTypeEnum.getEnum() as ReportTypeEnumInterface,
    };
  },
  computed: {
    childReportTypeInput: {
      // NOTE: computed で getter, setter を使用すると this の型推論ができなくなるケースあり
      get(this: any) {
        return this.reportTypeInput;
      },
      set(val) {
        return this.$emit("update:reportTypeInput", val);
      },
    },
    childReportTypeDialog: {
      get() {
        return this.reportTypeDialog;
      },
      set(val) {
        return this.$emit("update:reportTypeDialog", val);
      },
    },
    childReportTypeInputDisplay: {
      get() {
        return this.reportTypeInputDisplay;
      },
      set(val) {
        return this.$emit("update:reportTypeInputDisplay", val);
      },
    },
  },
});
